import { useMemo, useState } from 'react';
import { VideoSegment } from '@/player-config/src/types/RemotionPlayerConfigTypes/Segment/VideoSegment';

export function useVideoSegmentDrag(segment: VideoSegment, fps: number) {
  const [dragStart, setDragStart] = useState(0);
  const [dragEnd, setDragEnd] = useState(0);

  const segmentWidth = useMemo(() => {
    const ds = dragStart || 0;
    const de = dragEnd || 0;

    let startTime = 0;
    let endTime = 0;

    if (ds || de) {
      if (!segment.currentBounds) {
        return 0;
      }
      startTime = segment.currentBounds.fromFrame / fps;
      endTime = segment.currentBounds.toFrame / fps;
    } else if (segment.segment_metadata?.start !== undefined && segment.segment_metadata?.end !== undefined) {
      startTime = segment.segment_metadata.start;
      endTime = segment.segment_metadata.end;
    } else if (segment.currentBounds) {
      startTime = segment.currentBounds.fromFrame / fps;
      endTime = segment.currentBounds.toFrame / fps;
    } else {
      return 0;
    }

    return (endTime + de - startTime - ds) * fps;
  }, [segment.segment_metadata?.start, segment.segment_metadata?.end, segment.currentBounds, dragStart, dragEnd, fps]);

  return {
    dragStart,
    dragEnd,
    setDragStart,
    setDragEnd,
    segmentWidth
  };
}
